var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEyereact = function SvgEyereact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M4.5 10.466C3.473 9.614 2.665 8.613 2.217 8c.449-.613 1.257-1.614 2.284-2.466C5.585 4.634 6.792 4 8.002 4s2.417.634 3.5 1.534c1.028.852 1.836 1.853 2.285 2.466-.449.613-1.257 1.614-2.284 2.466C10.417 11.366 9.21 12 8 12s-2.417-.634-3.5-1.534M8.002 2c-1.888 0-3.543.97-4.778 1.994C1.973 5.032 1.03 6.227.543 6.9a1.87 1.87 0 0 0 0 2.2c.486.673 1.43 1.868 2.68 2.906C4.458 13.03 6.113 14 8.001 14s3.543-.97 4.778-1.994c1.25-1.038 2.194-2.233 2.68-2.906a1.87 1.87 0 0 0 0-2.2c-.486-.673-1.43-1.868-2.68-2.906C11.544 2.97 9.888 2 8 2m0 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  })));
};
export default SvgEyereact;